import * as Sentry from "@sentry/react"

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN

export function initSentry() {
  if (!SENTRY_DSN) return

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,
    ignoreErrors: [
      /^ResizeObserver loop/,
      /^Non-Error promise rejection captured/,
      "Failed to fetch",
      "NetworkError",
      "Load failed",
    ],
    beforeSend(event) {
      if (event.request?.url) {
        try {
          const url = new URL(event.request.url)
          url.searchParams.delete("token")
          event.request.url = url.toString()
        } catch {
          // leave as-is
        }
      }
      return event
    },
  })
}

export function setSentryUser(userId: string, email?: string) {
  Sentry.setUser({ id: userId, email })
}

export function clearSentryUser() {
  Sentry.setUser(null)
}

export { Sentry }
